// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#userDropdown {\n  cursor: pointer;\n}", "",{"version":3,"sources":["webpack://./src/modules/navigation/components/top-nav-user/top-nav-user.component.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;AADJ","sourcesContent":["@import 'styles/core/variables.scss';\n\n#userDropdown {\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
